import { admin2 } from '@/api/instance'

const baseUrl = (shopId) => {
  return `/${shopId}/shopCustomModule`
}

//= > 建立 AC2000 客戶端設定
// admin.shopCustomModule.createAc2000Client
// POST /:ShopId/shopCustomModule/ac2000
export const CreateAc2000Client = async ({
  shopId,
  config,
  enabled = true,
}) => {
  return admin2({
    method: 'post',
    url: `${baseUrl(shopId)}/ac2000`,
    data: {
      enabled,
      config,
    },
  })
}

//= > 更新 AC2000 客戶端設定
// admin.shopCustomModule.updateAc2000Client
// PUT /:ShopId/shopCustomModule/ac2000
export const UpdateAc2000Client = async ({
  shopId,
  config,
  enabled = true,
}) => {
  return admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/ac2000`,
    data: {
      enabled,
      config,
    },
  })
}

//= > 取得 AC2000 客戶端設定
// 使用通用 shopCustomModule API with GetCustomModule，搭配 type 參數
// 注意：此函數應搭配 src/api/customModule.js 中的 GetCustomModule 使用
export const GetAc2000Client = async ({
  shopId,
}) => {
  return admin2({
    method: 'get',
    url: baseUrl(shopId),
    params: {
      type: 'ac2000',
    },
  })
}

//= > 建立全識門禁模組串接設定
// admin.shopCustomModule.createAguardClient
// POST /api-admin/:ShopId/shopCustomModule/aguard
export const CreateAguardClient = async ({
  shopId,
  config,
  enabled = true,
}) => {
  return admin2({
    method: 'post',
    url: `${baseUrl(shopId)}/aguard`,
    data: {
      enabled,
      config,
    },
  })
}

//= > 更新全識門禁模組串接設定
// admin.shopCustomModule.updateAguardClient
// PUT /api-admin/:ShopId/shopCustomModule/aguard
export const UpdateAguardClient = async ({
  shopId,
  config,
  enabled = true,
}) => {
  return admin2({
    method: 'put',
    url: `${baseUrl(shopId)}/aguard`,
    data: {
      enabled,
      config,
    },
  })
}
